module.exports = __webpack_public_path__ + "static/media/promo.45a383f0.gif";